.title {
  flex: 1;
  min-width: 0;
}

.timestamp {
  flex-shrink: 0;
  white-space: nowrap;
}
